import React from "react";

/**
 * Silueta de perro Kiltro — SVG inline, 100% negro, sin fondo.
 * Se adapta al tamaño del contenedor (width/height 100%) y hereda color via `currentColor`.
 */
export default function KiltroDogIcon({ size = 72, className = "", title = "Perro Kiltro" }) {
  return (
    <svg
      viewBox="0 0 128 96"
      fill="currentColor"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      aria-label={title}
      className={className}
    >
      {/* Cabeza */}
      <path d="M92 20 L100 14 L108 16 L112 22 L114 30 L110 36 L104 34 L92 34 Z" />
      {/* Oreja puntiaguda */}
      <path d="M100 14 L102 4 L110 10 L108 16 Z" />
      {/* Hocico */}
      <path d="M110 28 L122 30 L120 36 L112 36 Z" />
      {/* Ojo */}
      <circle cx="105" cy="25" r="1.6" fill="#FFF" />
      {/* Cuerpo principal */}
      <path d="M24 44 Q20 42 20 48 L20 62 L28 62 L28 76 L38 76 L38 64 L66 64 L66 76 L76 76 L76 64 L88 60 L96 54 L96 42 L92 34 L60 34 Q40 34 24 44 Z" />
      {/* Pata delantera izquierda */}
      <path d="M28 62 L28 86 L36 86 L36 62 Z" />
      {/* Pata delantera derecha */}
      <path d="M40 64 L40 82 L46 82 L46 64 Z" opacity="0.55" />
      {/* Pata trasera izquierda */}
      <path d="M66 64 L66 86 L74 86 L74 64 Z" />
      {/* Pata trasera derecha */}
      <path d="M78 64 L78 82 L84 82 L84 64 Z" opacity="0.55" />
      {/* Cola levantada */}
      <path d="M20 44 L10 30 L6 34 L16 48 Z" />
      {/* Huellitas */}
      <circle cx="4" cy="92" r="2" />
      <circle cx="12" cy="88" r="1.5" />
      <circle cx="110" cy="92" r="2" />
      <circle cx="118" cy="88" r="1.5" />
    </svg>
  );
}
